import some from "lodash/some";
import { decodeParam, encodeParam } from "@/utils/search";
import { BlogTags } from "@cgc/core/utils/tags";

export const PER_PAGE = 20;

export const BLOG_SEARCH_INDEX_NAME = "blogPost";

export const MAIN_SEARCH_INDEX_ID = BLOG_SEARCH_INDEX_NAME;
export const FEATURED_SEARCH_INDEX_ID = "blogPostFeatured";

export const featuredBlogConfigureDefaultProps = {
  hitsPerPage: 2,
  filters: `tag:='${BlogTags.Featured}'`,
};

export const searchStateMapping = {
  stateToRoute(uiState) {
    const { query, page, menu } = uiState[MAIN_SEARCH_INDEX_ID];
    const tag = menu?.tag;
    const category = menu?.category;

    return {
      ...(query ? { q: encodeParam(query) } : null),
      ...(tag ? { tag: encodeParam(tag) } : null),
      ...(category ? { category: encodeParam(category) } : null),
      ...(page ? { page } : null),
    };
  },
  routeToState(routeState) {
    const { q, tag, category, page } = routeState;
    const isSearch = some([q, page, tag, category]);

    return {
      ...(!isSearch
        ? {
            [FEATURED_SEARCH_INDEX_ID]: {
              configure: featuredBlogConfigureDefaultProps,
            },
          }
        : null),
      [MAIN_SEARCH_INDEX_ID]: {
        ...(q ? { query: decodeParam(q) } : null),
        ...(tag || category
          ? {
              menu: {
                ...(category ? { category: decodeParam(category) } : null),
                ...(tag ? { tag: decodeParam(tag) } : null),
              },
            }
          : null),
        ...(page ? { page } : null),
      },
    };
  },
};

export const BLOG_SEARCH_RESULTS_ANCHOR = "id_search_results_anchor";
export const scrollToResults = () => {
  const element = document.getElementById(BLOG_SEARCH_RESULTS_ANCHOR);
  element?.scrollIntoView();
};

export type InitialSearch = {
  tag?: string;
  category?: string;
};
